import ApplicationModel, { attr } from '../ApplicationModel';
import { type ProjectRisksConfigurationAttributes } from './generated/ProjectRisksConfigurationAttributes';
import { model } from '../modelBuilder';

interface ProjectRisksConfiguration
  extends ProjectRisksConfigurationAttributes {}

@model
class ProjectRisksConfiguration extends ApplicationModel {
  // Start auto-generated
  static typename: 'ProjectRisksConfiguration' = 'ProjectRisksConfiguration';
  get typename(): 'ProjectRisksConfiguration' {
    return 'ProjectRisksConfiguration';
  }

  static internalTypename: 'ProjectRisksConfiguration' =
    'ProjectRisksConfiguration';
  get internalTypename(): 'ProjectRisksConfiguration' {
    return 'ProjectRisksConfiguration';
  }

  static fields = {
    createdAt: attr({ readable: true }),
    dependenciesNotStarted: attr({ readable: true }),
    dependenciesPastDue: attr({ readable: true }),
    dependenciesPastDueConfig: attr({ readable: true }),
    disableOnParkingLots: attr({ readable: true }),
    enabled: attr({ readable: true }),
    exceedingDueDate: attr({ readable: true }),
    exceedingDueDateConfig: attr({ readable: true }),
    exceedingReleaseDate: attr({ readable: true }),
    exceedingReleaseDateConfig: attr({ readable: true }),
    id: attr({ readable: true }),
    iterationChurn: attr({ readable: true }),
    iterationChurnConfig: attr({ readable: true }),
    manuallyFlagged: attr({ readable: true }),
    nearingDueDate: attr({ readable: true }),
    nearingDueDateConfig: attr({ readable: true }),
    nearingReleaseDate: attr({ readable: true }),
    nearingReleaseDateConfig: attr({ readable: true }),
    noAssignee: attr({ readable: true }),
    noDetailedEstimate: attr({ readable: true }),
    noIteration: attr({ readable: true }),
    noProgramIncrement: attr({ readable: true }),
    noTeam: attr({ readable: true }),
    notScheduled: attr({ readable: true }),
    projectId: attr({ readable: true }),
    startedLate: attr({ readable: true }),
    startedLateConfig: attr({ readable: true }),
    statusChurn: attr({ readable: true }),
    statusChurnConfig: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    workStalled: attr({ readable: true }),
    workStalledConfig: attr({ readable: true }),
    project: attr.belongsTo({ readable: true, typename: 'Project' }),
  };
  // End auto-generated
}

export default ProjectRisksConfiguration;
